export const AUTHENTICATION = "AUTH/authentication";
export const LOGIN = "AUTH/login";
export const LOGOUT = "AUTH/logout";

export const PROFILE = "ADMIN/profile";
export const CHANGE_PASSWORD = "ADMIN/change_password";
